// extracted by mini-css-extract-plugin
module.exports = {"myAccountDatiView":"MyAccountDatiView_myAccountDatiView___SJM1","rotation":"MyAccountDatiView_rotation__XEsEo"};